// import { useState, useMemo } from 'react';
// import Breadcrumb from '@components/Shared/Breadcrumb';
// import { Card, CardHeader, CardFooter } from '@components/card/card';
// import { useTranslation } from 'react-i18next';
// import Loading from '@components/Shared/Loader/Loading';
// import useGetApInvoicesList from '@hooks/Finance/ApInvoices/useGetApInvoicesList';
// import NeatixModal from '@components/Modal/NeatixModal';
// import AddCreateAccountApInvoices from './AddCreateAccountApInvoices';
// import Select from 'react-select';
// import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
// import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';
// import Pagination from '@components/Shared/Pagination/Pagination';

// const ListApInvoices = () => {
//   const [showModal, setShowModal] = useState(false);
//   const [selectedApInvoices, setSelectedApInvoices] = useState<any[]>([]);

//   // ✅ حالة الفلاتر الجديدة
//   const [supplierFilter, setSupplierFilter] = useState<any>(null);
//   const [organizationFilter, setOrganizationFilter] = useState<any>(null);
//   const [dateFrom, setDateFrom] = useState('');
//   const [dateTo, setDateTo] = useState('');
//   const [activeFiltersCount, setActiveFiltersCount] = useState(0);

//   // ✅ حالة Pagination
//   const [currentPage, setCurrentPage] = useState(1);
//   const [dataPerPage, setDataPerPage] = useState(15);

//   const { t, i18n } = useTranslation();
//   const { OperatingUnitOptions } = useGetOperatingUnitWithPermission();
//   const { OptionSuppliers } = useGetSuppliersList();
//   const { ApInvoicesList, loading, error } = useGetApInvoicesList();

//   // ✅ تصفية البيانات بناءً على الفلاتر
//   const filteredData = useMemo(() => {
//     let filtered = ApInvoicesList?.filter(f => !f.postedFlag) || [];

//     if (supplierFilter) {
//       filtered = filtered.filter(item => item.peopleId === supplierFilter.value);
//     }

//     if (organizationFilter) {
//       filtered = filtered.filter(item => item.organizationId === organizationFilter.value);
//     }

//     if (dateFrom) {
//       filtered = filtered.filter(item => new Date(item.invoiceDate) >= new Date(dateFrom));
//     }

//     if (dateTo) {
//       filtered = filtered.filter(item => new Date(item.invoiceDate) <= new Date(dateTo));
//     }

//     // حساب عدد الفلاتر النشطة
//     const count = [supplierFilter ? 1 : 0, organizationFilter ? 1 : 0, dateFrom ? 1 : 0, dateTo ? 1 : 0].reduce(
//       (a, b) => a + b,
//       0
//     );

//     setActiveFiltersCount(count);
//     setCurrentPage(1); // إعادة تعيين الصفحة إلى الأولى عند تغيير الفلاتر

//     return filtered;
//   }, [ApInvoicesList, supplierFilter, organizationFilter, dateFrom, dateTo]);

//   // ✅ حساب البيانات المعروضة للصفحة الحالية
//   const displayedData = useMemo(() => {
//     const startIndex = (currentPage - 1) * dataPerPage;
//     const endIndex = startIndex + dataPerPage;
//     return filteredData.slice(startIndex, endIndex);
//   }, [filteredData, currentPage, dataPerPage]);

//   const handleCheckboxChange = (item: any) => {
//     setSelectedApInvoices(prevSelected => {
//       const isSelected = prevSelected?.some(selected => selected.id === item.id);

//       if (isSelected) {
//         return prevSelected?.filter(selected => selected.id !== item.id);
//       } else {
//         return [...prevSelected, item];
//       }
//     });
//   };

//   const handleSelectAll = () => {
//     // اختيار جميع البيانات المعروضة فقط
//     if (selectedApInvoices.length === displayedData.length) {
//       setSelectedApInvoices([]);
//     } else {
//       setSelectedApInvoices([...displayedData]);
//     }
//   };

//   const handleSelectAllFiltered = () => {
//     // اختيار جميع البيانات بعد التصفية
//     if (selectedApInvoices.length === filteredData.length) {
//       setSelectedApInvoices([]);
//     } else {
//       setSelectedApInvoices([...filteredData]);
//     }
//   };

//   const handleOpenAddCreateAccount = () => {
//     if (selectedApInvoices?.length > 0) {
//       setShowModal(true);
//     }
//   };

//   // ✅ دالة تطبيق الفلاتر (إعادة جلب البيانات)

//   // ✅ دالة Pagination
//   const handlePagination = (page: number) => {
//     setCurrentPage(page);
//   };

//   const getPostedFlagBadge = (flag: boolean) =>
//     flag ? (
//       <span className='badge bg-success'>
//         <i className='fas fa-check me-1'></i>
//         {t('Posted')}
//       </span>
//     ) : (
//       <span className='badge bg-danger'>
//         <i className='fas fa-times me-1'></i>
//         {t('NotPosted')}
//       </span>
//     );

//   const getInvoiceTypeBadge = (type: string) => {
//     switch (type) {
//       case 'Standard':
//         return (
//           <span className='badge bg-primary'>
//             <i className='fas fa-file-invoice me-1'></i>
//             {t('Standard')}
//           </span>
//         );
//       case 'CreditMemo':
//       case 'DebitMemo':
//         return (
//           <span className='badge bg-warning text-dark'>
//             <i className='fas fa-file-invoice-dollar me-1'></i>
//             {t('DebitMemo')}
//           </span>
//         );
//       default:
//         return (
//           <span className='badge bg-secondary'>
//             <i className='fas fa-file me-1'></i>
//             {type}
//           </span>
//         );
//     }
//   };

//   const getReferenceTypeBadge = (refType: string) => {
//     switch (refType) {
//       case 'Bill':
//         return (
//           <span className='badge bg-success text-dark'>
//             <i className='fas fa-shopping-cart me-1'></i>
//             {t('أمر شـــراء')}
//           </span>
//         );
//       case 'EXP':
//         return (
//           <span className='badge bg-dark'>
//             <i className='fas fa-receipt me-1'></i>
//             {t('مصروفات')}
//           </span>
//         );
//       case 'EXP_FAST':
//         return (
//           <span className='badge bg-dark'>
//             <i className='fas fa-receipt me-1'></i>
//             {t('مصروفات سريــعة')}
//           </span>
//         );
//       case 'DebitMemo':
//         return (
//           <span className='badge bg-warning text-dark'>
//             <i className='fas fa-file-invoice-dollar me-1'></i>
//             {t('مردود مشتريات')}
//           </span>
//         );
//       case 'Discount':
//         return (
//           <span className='badge bg-info'>
//             <i className='fas fa-percentage me-1'></i>
//             {t('خصم')}
//           </span>
//         );
//       default:
//         return (
//           <span className='badge bg-info text-dark'>
//             <i className='fas fa-keyboard me-1'></i>
//             {t('يدوي')}
//           </span>
//         );
//     }
//   };

//   const formatAmount = (amount: number) => {
//     return new Intl.NumberFormat(i18n.language, {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2
//     }).format(amount);
//   };

//   const breadcrumbList = [
//     { name: t('Home'), link: '/AP/HomePage' },
//     { name: t('PostPaymentInvoices'), link: null }
//   ];

//   return (
//     <>
//       <div className='d-flex flex-wrap align-items-center gap-2'>
//         <Breadcrumb BreadcrumbList={breadcrumbList} PageName={t('PostPaymentInvoices')} />

//         <div className='ms-auto d-flex gap-2'>
//           {/* <button
//             type='button'
//             className='btn btn-outline-theme'
//             onClick={handleSelectAllFiltered}
//             disabled={filteredData.length === 0}
//           >
//             <i className='fas fa-check-square me-1'></i>
//             {selectedApInvoices.length === filteredData.length ? t('DeselectAll') : t('SelectAll')}
//           </button> */}

//           <button
//             type='button'
//             className='btn btn-theme'
//             onClick={handleOpenAddCreateAccount}
//             disabled={selectedApInvoices.length === 0}
//           >
//             <i className='fa fa-share-square fa-fw me-1'></i>
//             {t('PostSelectedInvoices')} ({selectedApInvoices.length})
//           </button>
//         </div>
//       </div>

//       <Card className='mb-4'>
//         <CardHeader>
//           <div className='row g-2'>
//             {/* ✅ فلترة بوحدة التشغيل */}
//             <div className='col-lg-4'>
//               <div className='input-group'>
//                 <span className='input-group-text fw-bold'>
//                   <i className='fas fa-building'></i>
//                 </span>
//                 <Select
//                   value={organizationFilter}
//                   onChange={setOrganizationFilter}
//                   options={OperatingUnitOptions}
//                   placeholder={t('اختر وحدة تشغيـل')}
//                   isClearable
//                   isSearchable
//                   className='flex-grow-1'
//                   classNamePrefix='react-select'
//                   menuPortalTarget={document.body}
//                   styles={{
//                     menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
//                   }}
//                 />
//               </div>
//             </div>

//             {/* ✅ فلترة بالمورد */}
//             <div className='col-lg-4'>
//               <div className='input-group'>
//                 <span className='input-group-text fw-bold'>
//                   <i className='fas fa-truck'></i>
//                 </span>
//                 <Select
//                   value={supplierFilter}
//                   onChange={setSupplierFilter}
//                   options={OptionSuppliers}
//                   placeholder={t('اختر مورد')}
//                   isClearable
//                   isSearchable
//                   className='flex-grow-1'
//                   classNamePrefix='react-select'
//                   menuPortalTarget={document.body}
//                   styles={{
//                     menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
//                   }}
//                 />
//               </div>
//             </div>

//             {/* ✅ التاريخ من وإلى */}
//             <div className='col-lg-4'>
//               <div className='input-group'>
//                 <span className='input-group-text'>
//                   <i className='fas fa-calendar-alt text-muted'></i>
//                 </span>
//                 <input
//                   type='date'
//                   className='form-control border-start-0'
//                   value={dateFrom}
//                   onChange={e => setDateFrom(e.target.value)}
//                   placeholder={t('From')}
//                 />
//                 <span className='input-group-text'>-</span>
//                 <input
//                   type='date'
//                   className='form-control'
//                   value={dateTo}
//                   onChange={e => setDateTo(e.target.value)}
//                   placeholder={t('To')}
//                 />
//               </div>
//             </div>
//           </div>
//         </CardHeader>

//         <Loading loading={loading} error={error}>
//           <div className='table-responsive'>
//             <table className='table table-hover mb-0'>
//               <thead className='bg-theme bg-opacity-25 fw-bold'>
//                 <tr>
//                   <th className='small text-center'>
//                     <div className='form-check'>
//                       <input
//                         type='checkbox'
//                         className='form-check-input'
//                         checked={
//                           displayedData.length > 0 &&
//                           selectedApInvoices.length === displayedData.length &&
//                           displayedData.every(item => selectedApInvoices.some(selected => selected.id === item.id))
//                         }
//                         onChange={handleSelectAll}
//                       />
//                     </div>
//                   </th>
//                   <th className='small'>{t('InvoiceNumber')}</th>
//                   <th className='small'>{t('Supplier')}</th>
//                   <th className='small'>{t('InvoiceDate')}</th>
//                   <th className='small'>{t('Amount')}</th>
//                   <th className='small text-center'>{t('PostingStatus')}</th>
//                   <th className='small'>{t('InvoiceType')}</th>
//                   <th className='small'>{t('المصدر')}</th>
//                   <th className='small'>{t('وحدة التشغيـل')}</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {displayedData.length > 0 ? (
//                   displayedData.map((item: any) => (
//                     <tr key={item.id}>
//                       <td className='align-middle text-center'>
//                         <div className='form-check'>
//                           <input
//                             type='checkbox'
//                             className='form-check-input'
//                             checked={selectedApInvoices.some(selected => selected.id === item.id)}
//                             onChange={() => handleCheckboxChange(item)}
//                           />
//                         </div>
//                       </td>
//                       <td className='align-middle'>
//                         <strong className='text-theme'>{item.invoiceNum}</strong>
//                       </td>
//                       <td className='align-middle'>
//                         <div className='d-flex flex-column'>
//                           <strong className='fw-bold'>
//                             {i18n.language === 'en' ? item.peopleName : item.peopleName2}
//                           </strong>
//                           {item.peopleCode && (
//                             <small className='text-muted'>
//                               {t('Code')}: {item.peopleCode}
//                             </small>
//                           )}
//                         </div>
//                       </td>
//                       <td className='align-middle'>{item.invoiceDate}</td>
//                       <td className='align-middle'>
//                         <span className='fw-bold text-theme'>{formatAmount(item.invoiceAmount)}</span>
//                       </td>
//                       <td className='align-middle text-center'>{getPostedFlagBadge(item.postedFlag || false)}</td>
//                       <td className='align-middle'>{getInvoiceTypeBadge(item.invoiceType)}</td>
//                       <td className='align-middle'>{getReferenceTypeBadge(item.referenceType)}</td>
//                       <td className='align-middle'>
//                         {i18n.language === 'en' ? item.organizationName : item.organizationName2}
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan={9} className='text-center py-4 text-muted'>
//                       <i className='fa fa-inbox fa-2x mb-2'></i>
//                       <br />
//                       {activeFiltersCount > 0 ? t('NoSearchResults') : t('NoInvoicesRegistered')}
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </Loading>

//         <CardFooter>
//           <div className='d-flex align-items-center gap-3'></div>
//           {/* Pagination Component */}
//           <Pagination
//             filteredData={filteredData}
//             dataPerPage={dataPerPage}
//             handlePagination={handlePagination}
//             currentPage={currentPage}
//           />
//         </CardFooter>
//       </Card>

//       <NeatixModal
//         show={showModal}
//         setShow={setShowModal}
//         // bodyClassName='p-0'
//         size='xl'
//         showHeader={false}
//         backdrop
//       >
//         {selectedApInvoices?.length > 0 && (
//           <AddCreateAccountApInvoices
//             selectedApInvoices={selectedApInvoices}
//             onClose={() => {
//               setShowModal(false);
//               setSelectedApInvoices([]);
//               // refetch(); // إعادة تحميل البيانات بعد الترحيل
//             }}
//           />
//         )}
//       </NeatixModal>
//     </>
//   );
// };

// export default ListApInvoices;

import { useEffect, useMemo, useState } from 'react';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { Card, CardHeader, CardFooter } from '@components/card/card';
import { useTranslation } from 'react-i18next';
import Loading from '@components/Shared/Loader/Loading';
import NeatixModal from '@components/Modal/NeatixModal';
import AddCreateAccountApInvoices from './AddCreateAccountApInvoices';
import Select from 'react-select';

import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';

import { useAppDispatch, useAppSelector } from '@store/hooks';
import { getPagedData, setEndpoint, setFilters } from '@store/DynamicSlice/dynamicTableSlice';
import { DynamicFilter } from '@Helper/DynamicFilter/DynamicFilter';
import { DynamicPagination } from '@Helper/DynamicFilter/DynamicPagination';

const TABLE_KEY = 'ApInvoices_unPosted_Index';

const ListApInvoices = () => {
  const dispatch = useAppDispatch();
  const tableState = useAppSelector(state => state.dynamicTable[TABLE_KEY]);

  const data = tableState?.data ?? [];
  const loading = tableState?.loading ?? false;
  const error = tableState?.error ?? null;
  const filters = tableState?.filters ?? [];

  const [showFilters, setShowFilters] = useState(false);

  const [showModal, setShowModal] = useState(false);

  // ✅ Selection (يحافظ على الاختيار عند التنقل بين الصفحات)
  const [selectedMap, setSelectedMap] = useState<Record<string, any>>({});

  // ✅ Inline Filters
  const [supplierFilter, setSupplierFilter] = useState<any>(null);
  const [organizationFilter, setOrganizationFilter] = useState<any>(null);
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [activeFiltersCount, setActiveFiltersCount] = useState(0);

  const { t, i18n } = useTranslation();
  const { OperatingUnitOptions } = useGetOperatingUnitWithPermission();
  const { OptionSuppliers } = useGetSuppliersList();

  useEffect(() => {
    dispatch(setEndpoint({ tableKey: TABLE_KEY, endpoint: 'Ap/GetApInvoicesList_unPosted_Paged' }));
    dispatch(getPagedData({ tableKey: TABLE_KEY }));
  }, [dispatch]);

  useEffect(() => {
    setActiveFiltersCount(filters.length);
  }, [filters]);

  const selectedApInvoices = useMemo(() => Object.values(selectedMap), [selectedMap]);

  const generateFilterId = () => `filter-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

  const applyFilters = () => {
    const newFilters: any[] = [];

    if (supplierFilter) {
      newFilters.push({
        id: generateFilterId(),
        field: 'peopleId',
        operator: 0, // OpEquals
        value: supplierFilter.value
      });
    }

    if (organizationFilter) {
      newFilters.push({
        id: generateFilterId(),
        field: 'organizationId',
        operator: 0, // OpEquals
        value: organizationFilter.value
      });
    }

    if (dateFrom) {
      newFilters.push({
        id: generateFilterId(),
        field: 'invoiceDate',
        operator: 3, // OpGreaterOrEqual
        value: dateFrom
      });
    }

    if (dateTo) {
      newFilters.push({
        id: generateFilterId(),
        field: 'invoiceDate',
        operator: 5, // OpLessOrEqual
        value: dateTo
      });
    }

    // ✅ يطبق الفلاتر على السيرفر
    dispatch(setFilters({ tableKey: TABLE_KEY, filters: newFilters }));
    dispatch(getPagedData({ tableKey: TABLE_KEY }));

    // ✅ اختياري: امسح الاختيارات لأن النتائج تغيّرت
    setSelectedMap({});
  };

  const clearFilters = () => {
    setSupplierFilter(null);
    setOrganizationFilter(null);
    setDateFrom('');
    setDateTo('');

    dispatch(setFilters({ tableKey: TABLE_KEY, filters: [] }));
    dispatch(getPagedData({ tableKey: TABLE_KEY }));

    setSelectedMap({});
  };

  const handleCheckboxChange = (item: any) => {
    setSelectedMap(prev => {
      const next = { ...prev };
      if (next[item.id]) delete next[item.id];
      else next[item.id] = item;
      return next;
    });
  };

  const isAllPageSelected = data.length > 0 && data.every((x: any) => !!selectedMap[x.id]);

  const handleSelectAllPage = () => {
    setSelectedMap(prev => {
      const next = { ...prev };

      if (isAllPageSelected) {
        // remove current page items
        data.forEach((x: any) => {
          if (next[x.id]) delete next[x.id];
        });
      } else {
        // add current page items
        data.forEach((x: any) => {
          next[x.id] = x;
        });
      }

      return next;
    });
  };

  const handleOpenAddCreateAccount = () => {
    if (selectedApInvoices.length > 0) setShowModal(true);
  };

  const getPostedFlagBadge = (flag: boolean) =>
    flag ? (
      <span className='badge bg-success'>
        <i className='fas fa-check me-1'></i>
        {t('Posted')}
      </span>
    ) : (
      <span className='badge bg-danger'>
        <i className='fas fa-times me-1'></i>
        {t('NotPosted')}
      </span>
    );

  const getInvoiceTypeBadge = (type: string) => {
    switch (type) {
      case 'Standard':
        return (
          <span className='badge bg-primary'>
            <i className='fas fa-file-invoice me-1'></i>
            {t('Standard')}
          </span>
        );
      case 'CreditMemo':
      case 'DebitMemo':
        return (
          <span className='badge bg-warning text-dark'>
            <i className='fas fa-file-invoice-dollar me-1'></i>
            {t('DebitMemo')}
          </span>
        );
      default:
        return (
          <span className='badge bg-secondary'>
            <i className='fas fa-file me-1'></i>
            {type}
          </span>
        );
    }
  };

  // ✅ لاحقة (غير مخزني) حسب اللغة بدون مفاتيح ترجمة جديدة
  const nonInvSuffix = i18n.language === 'ar' ? ' (غير مخزني)' : ' (Non-Inventory)';

  const getReferenceTypeBadge = (refType: string) => {
    switch (refType) {
      case 'Bill':
        return (
          <span className='badge bg-success text-dark'>
            <i className='fas fa-shopping-cart me-1'></i>
            {t('أمر شـــراء')}
          </span>
        );
      case 'Bill_NonInventory':
        return (
          <span className='badge bg-success text-dark'>
            <i className='fas fa-shopping-cart me-1'></i>
            {t('أمر شـــراء')}
            {nonInvSuffix}
          </span>
        );
      case 'EXP':
        return (
          <span className='badge bg-dark'>
            <i className='fas fa-receipt me-1'></i>
            {t('مصروفات')}
          </span>
        );
      case 'EXP_FAST':
        return (
          <span className='badge bg-dark'>
            <i className='fas fa-receipt me-1'></i>
            {t('مصروفات سريــعة')}
          </span>
        );
      case 'DebitMemo':
        return (
          <span className='badge bg-warning text-dark'>
            <i className='fas fa-file-invoice-dollar me-1'></i>
            {t('مردود مشتريات')}
          </span>
        );
      case 'DebitMemo_NonInventory':
        return (
          <span className='badge bg-warning text-dark'>
            <i className='fas fa-file-invoice-dollar me-1'></i>
            {t('مردود مشتريات')}
            {nonInvSuffix}
          </span>
        );
      case 'Discount':
        return (
          <span className='badge bg-info'>
            <i className='fas fa-percentage me-1'></i>
            {t('خصم')}
          </span>
        );
      default:
        return (
          <span className='badge bg-info text-dark'>
            <i className='fas fa-keyboard me-1'></i>
            {t('يدوي')}
          </span>
        );
    }
  };

  const formatAmount = (amount: number) => {
    return new Intl.NumberFormat(i18n.language, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount);
  };

  // ✅ حقول DynamicFilter (السلايدر)
  const fields: any = [
    { name: 'invoiceNum', label: t('InvoiceNumber'), type: 'string' },
    {
      name: 'invoiceType',
      label: t('InvoiceType'),
      type: 'options',
      options: [
        { value: 'Standard', label: t('Standard') },
        { value: 'CreditMemo', label: t('DebitMemo') }
      ]
    },
    {
      name: 'referenceType',
      label: t('مصدر الفاتورة'),
      type: 'options',
      options: [
        { value: 'Bill', label: t('PurchaseOrder') },
        { value: 'Bill_NonInventory', label: `${t('PurchaseOrder')}${nonInvSuffix}` },
        { value: 'EXP', label: t('Expenses') },
        { value: 'EXP_FAST', label: t('مصروفات سريعة') },
        { value: 'DebitMemo', label: t('PurchaseReturn') },
        { value: 'DebitMemo_NonInventory', label: `${t('PurchaseReturn')}${nonInvSuffix}` },
        { value: 'Discount', label: t('خصم') },
        { value: 'Manual', label: t('يدوي') }
      ]
    },
    { name: 'invoiceDate', label: t('InvoiceDate'), type: 'date' },
    { name: 'peopleId', label: t('Supplier'), type: 'options', options: OptionSuppliers },
    { name: 'organizationId', label: t('OperatingUnit'), type: 'options', options: OperatingUnitOptions }
  ];

  const breadcrumbList = [
    { name: t('Home'), link: '/AP/HomePage' },
    { name: t('PostPaymentInvoices'), link: null }
  ];

  return (
    <>
      <div className='d-flex flex-wrap align-items-center gap-2'>
        <Breadcrumb BreadcrumbList={breadcrumbList} PageName={t('PostPaymentInvoices')} />

        <div className='ms-auto d-flex gap-2'>
          <button
            type='button'
            className='btn btn-theme'
            onClick={handleOpenAddCreateAccount}
            disabled={selectedApInvoices.length === 0}
          >
            <i className='fa fa-share-square fa-fw me-1'></i>
            {t('PostSelectedInvoices')} ({selectedApInvoices.length})
          </button>
        </div>
      </div>

      <Card className='mb-4'>
        <CardHeader>
          <div className='row g-2'>
            {/* ✅ فلترة بوحدة التشغيل */}
            <div className='col-lg-3'>
              <div className='input-group'>
                <span className='input-group-text fw-bold'>
                  <i className='fas fa-building'></i>
                </span>
                <Select
                  value={organizationFilter}
                  onChange={setOrganizationFilter}
                  options={OperatingUnitOptions}
                  placeholder={t('اختر وحدة تشغيـل')}
                  isClearable
                  isSearchable
                  className='flex-grow-1'
                  classNamePrefix='react-select'
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
                />
              </div>
            </div>

            {/* ✅ فلترة بالمورد */}
            <div className='col-lg-3'>
              <div className='input-group'>
                <span className='input-group-text fw-bold'>
                  <i className='fas fa-truck'></i>
                </span>
                <Select
                  value={supplierFilter}
                  onChange={setSupplierFilter}
                  options={OptionSuppliers}
                  placeholder={t('اختر مورد')}
                  isClearable
                  isSearchable
                  className='flex-grow-1'
                  classNamePrefix='react-select'
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
                />
              </div>
            </div>

            {/* ✅ التاريخ من وإلى */}
            <div className='col-lg-4'>
              <div className='input-group'>
                <span className='input-group-text'>
                  <i className='fas fa-calendar-alt text-muted'></i>
                </span>
                <input
                  type='date'
                  className='form-control border-start-0'
                  value={dateFrom}
                  onChange={e => setDateFrom(e.target.value)}
                  placeholder={t('From')}
                />
                <span className='input-group-text'>-</span>
                <input
                  type='date'
                  className='form-control'
                  value={dateTo}
                  onChange={e => setDateTo(e.target.value)}
                  placeholder={t('To')}
                />
              </div>
            </div>

            {/* ✅ أزرار التطبيق والمسح + السلايدر */}
            <div className='col-lg-2 text-end'>
              <button
                className='btn btn-outline-secondary me-2'
                type='button'
                onClick={clearFilters}
                title={t('ClearFilters')}
                disabled={activeFiltersCount === 0}
              >
                <i className='fas fa-times fa-fw'></i>
              </button>

              <button
                className='btn btn-theme me-2'
                type='button'
                onClick={applyFilters}
                title={t('ApplyFilters')}
                disabled={!supplierFilter && !organizationFilter && !dateFrom && !dateTo}
              >
                <i className='fas fa-filter fa-fw'></i>
              </button>

              <button
                className='btn btn-outline-theme w-md-auto'
                onClick={() => setShowFilters(true)}
                title={t('SearchFilters')}
              >
                <i className='fas fa-sliders-h fa-fw'></i>
              </button>
            </div>
          </div>
        </CardHeader>

        <Loading loading={loading} error={error}>
          <div className='table-responsive'>
            <table className='table table-hover mb-0'>
              <thead className='bg-theme bg-opacity-25 fw-bold'>
                <tr>
                  <th className='small text-center'>
                    <div className='form-check'>
                      <input
                        type='checkbox'
                        className='form-check-input'
                        checked={isAllPageSelected}
                        onChange={handleSelectAllPage}
                      />
                    </div>
                  </th>

                  <th className='small'>{t('InvoiceNumber')}</th>
                  <th className='small'>{t('InvoiceDate')}</th>
                  <th className='small'>{t('Supplier')}</th>
                  <th className='small'>{t('Amount')}</th>
                  <th className='small'>{t('وحدة التشغيـل')}</th>
                  <th className='small'>{t('المصدر')}</th>
                  <th className='small'>{t('InvoiceType')}</th>
                  <th className='small text-center'>{t('PostingStatus')}</th>
                </tr>
              </thead>

              <tbody>
                {data.length > 0 ? (
                  data.map((item: any) => (
                     <tr key={item.id}>
  <td className='align-middle text-center'>
    <div className='form-check'>
      <input
        type='checkbox'
        className='form-check-input'
        checked={selectedApInvoices.some(selected => selected.id === item.id)}
        onChange={() => handleCheckboxChange(item)}
      />
    </div>
  </td>

  <td className='align-middle'>
    <strong className='text-theme'>{item.invoiceNum}</strong>
  </td>

  <td className='align-middle'>{item.invoiceDate}</td>

  <td className='align-middle'>
    <div className='d-flex flex-column'>
      <strong className='fw-bold'>{i18n.language === 'en' ? item.peopleName : item.peopleName2}</strong>
      {item.peopleCode && (
        <small className='text-muted'>
          {t('Code')}: {item.peopleCode}
        </small>
      )}
    </div>
  </td>

  <td className='align-middle'>
    <span className='fw-bold text-theme'>{formatAmount(item.invoiceAmount)}</span>
  </td>

  <td className='align-middle'>
    {i18n.language === 'en' ? item.organizationName : item.organizationName2}
  </td>

  <td className='align-middle'>{getReferenceTypeBadge(item.referenceType)}</td>

  <td className='align-middle'>{getInvoiceTypeBadge(item.invoiceType)}</td>

  <td className='align-middle text-center'>{getPostedFlagBadge(item.postedFlag || false)}</td>
</tr>

                  ))
                ) : (
                  <tr>
                    <td colSpan={9} className='text-center py-4 text-muted'>
                      <i className='fa fa-inbox fa-2x mb-2'></i>
                      <br />
                      {activeFiltersCount > 0 ? t('NoSearchResults') : t('NoInvoicesRegistered')}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </Loading>

        <CardFooter>
          <div className='text-theme'>
            <DynamicPagination tableKey={TABLE_KEY} maxVisiblePages={3} showItemsPerPage={true} />
          </div>
        </CardFooter>
      </Card>

      <DynamicFilter tableKey={TABLE_KEY} fields={fields} show={showFilters} onClose={() => setShowFilters(false)} />

      <NeatixModal show={showModal} setShow={setShowModal} size='xl' showHeader={false} backdrop>
        {selectedApInvoices.length > 0 && (
          <AddCreateAccountApInvoices
            selectedApInvoices={selectedApInvoices}
            onClose={() => {
              setShowModal(false);
              setSelectedMap({});
              // ✅ بعد الترحيل، رجّع البيانات
              dispatch(getPagedData({ tableKey: TABLE_KEY }));
            }}
          />
        )}
      </NeatixModal>
    </>
  );
};

export default ListApInvoices;
